<template>
  <mdb-tbl class="product-table" responsive>
    <mdb-tbl-head class="lighten-5" color="mdb-color">
      <tr>
        <th></th>
        <th class="font-weight-bold">
          <strong>Product</strong>
        </th>
        <th class="font-weight-bold">
          <strong>Price</strong>
        </th>
        <th class="font-weight-bold">
          <strong>Qty</strong>
        </th>
        <th class="font-weight-bold">
          <strong>Amount</strong>
        </th>
        <th></th>
      </tr>
    </mdb-tbl-head>
    <mdb-tbl-body>
      <!-- First row -->
      <tr v-for="item in currentCart.items" :key="item.id">
        <th scope="row">
          <img :src="item.imageThumb" alt="" class="img-fluid z-depth-0">
        </th>
        <td>
          <h5 class="mt-3">
            <strong>{{ item.name }}</strong>
          </h5>
          <p v-if="adminView && item.sku">
            <strong>SKU: </strong> {{item.sku}}
          </p>
          <p v-if="adminView">
            <strong>Item ID: </strong> {{item.id}}
          </p>
        </td>
        <td class="text-right">
          {{ currentCart.currencySymbol }} {{ item.price | formatNumber }}
        </td>
        <td class="text-right">
          {{ item.quantity }}
          <mdb-tooltip v-if="allowEdit"  :options="{placement: 'top'}" trigger="hover">
            <div>Change Quantity</div>
            <mdb-btn slot="reference" color="secondary" icon="pencil" size="sm"
                     @click="editQty(item)"></mdb-btn>
          </mdb-tooltip>
        </td>
        <td class="text-right">
          {{ currentCart.currencySymbol }} {{ item.total | formatNumber }}
        </td>
        <td>
          <mdb-tooltip v-if="allowEdit" :options="{placement: 'top'}" trigger="hover">
            <div>Remove item</div>
            <mdb-btn slot="reference" color="warning" icon="trash" size="sm"
                     @click="removeItem(item)"></mdb-btn>
          </mdb-tooltip>
        </td>

      </tr>

      <tr>
        <th></th>
        <td></td>
        <td></td>
        <td class="text-right">
          <h5>Sub Total</h5>
        </td>
        <td class="text-right">
          <h5>{{ currentCart.currencySymbol }} {{ currentCart.subTotal | formatNumber }}</h5>
        </td>
      </tr>
      <tr>
        <th></th>
        <td></td>
        <td></td>
        <td class="text-right">
          <h5>Tax</h5>
        </td>
        <td class="text-right">
          <h5>{{ currentCart.currencySymbol }} {{ currentCart.tax | formatNumber }}</h5>
        </td>
      </tr>
      <tr>
        <th></th>
        <td></td>
        <td></td>
        <td class="text-right">
          <h5>Shipping</h5>
        </td>
        <td class="text-right">
          <h5>{{ currentCart.currencySymbol }} {{ currentCart.shipping | formatNumber }}</h5>
        </td>
      </tr>
      <tr >
        <th></th>
        <td></td>
        <td></td>
        <td class="text-right">
          <h4>Total Due</h4>
        </td>
        <td class="text-right">
          <h4>{{ currentCart.currencySymbol }} {{ currentCart.totalDue | formatNumber }}
            <br/>
            ({{ currentCart.currencyCode }})
          </h4>
        </td>
      </tr>
    </mdb-tbl-body>
  </mdb-tbl>
</template>

<script>

import {mdbBtn, mdbTbl, mdbTblBody, mdbTblHead, mdbTooltip,} from "mdbvue";

export default {
  name: 'shopping-items',
  components: {
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbTooltip
  },
  filters: {
    formatNumber: function (val) {
      if (!val) return "0.00"
      return val.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  },
  props: {
    currentCart : {
      type: Object
    },
    allowEdit: {
      type: Boolean,
      default: false
    },
    adminView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    removeItem(item) {
      this.$emit("removeItem", item)
    },
    editQty(item) {
      this.$emit("editQty", item)
    }
  }

};
</script>
